<script setup lang="ts">
import { NxtDropdown } from '@future-harry/nxt-styles';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { ApplicationFields } from '@/core/collections/job-boards/job-board.interface';

const { t } = useI18n();

const options = computed(() => [
   { id: 'optional', name: t('job-board.settings.sollicitants.options.optional') },
   { id: 'required', name: t('job-board.settings.sollicitants.options.required') },
   { id: 'hide', name: t('job-board.settings.sollicitants.options.hide') },
]);

const model = defineModel<ApplicationFields>('modelValue', { required: true });
const keys = computed(() => Object.keys(model.value) as (keyof ApplicationFields)[]);

function appFieldToOption(value: boolean | null, key: keyof ApplicationFields) {
   if (key === 'name' || key === 'phone') return 'required';
   if (value === null) return 'hide';
   return value ? 'required' : 'optional';
}

function optionToAppField(option: string): boolean | null {
   if (option === 'hide') return null;
   return option === 'required';
}
</script>

<template>
   <div class="settings-form-layout">
      <div v-for="(key, index) in keys" :key="key" class="row">
         <div class="col-half">
            <label>{{ t(`job-board.settings.sollicitants.${key}`) }}</label>
         </div>
         <div class="col-half">
            <NxtDropdown
               autocomplete="off"
               :name="`sollicitant_field-${index}`"
               :options="options"
               :disabled="key === 'phone' || key === 'name'"
               :has-clear-option="false"
               :model-value="appFieldToOption(model[key], key)"
               @update:model-value="(v) => (model[key] = optionToAppField(v))"
            />
         </div>
      </div>
   </div>
</template>

<style scoped lang="scss">
.settings-form-layout {
   display: flex;
   flex-direction: column;
}
.row {
   display: flex;
   gap: var(--nxt-gutter);
}
</style>
